require('./brokerWarrantsAdvancedBuyView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const trim = require('lodash/string/trim');

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKButton } = require('commonsComponents/OKButton');

// @ components
const { BrokerWarrantsHeader } = require('components/broker/brokerProductHeaders/brokerWarrantsHeader/brokerWarrantsHeader');
const {
    BrokerWarrantsAdvancedBuyStep1
} = require('components/broker/brokerWarrantsAdvancedBuy/brokerWarrantsAdvancedBuyStep1/brokerWarrantsAdvancedBuyStep1');
const {
    BrokerWarrantsAdvancedBuyStep2
} = require('components/broker/brokerWarrantsAdvancedBuy/brokerWarrantsAdvancedBuyStep2/brokerWarrantsAdvancedBuyStep2');
const BrokerWarrantsAdvancesBuyStep3 = require('components/broker/brokerWarrantsAdvancedBuy/brokerWarrantsAdvancedBuyStep3/brokerWarrantsAdvancedBuyStep3');
const BrokerWarrantsAdvancedBuySuccess = require('components/broker/brokerWarrantsAdvancedBuy/brokerWarrantsAdvancedBuySuccess/brokerWarrantsAdvancedBuySuccess');
const { BrokerMiFIDBehavior } = require('mifid/components/brokerMiFIDBehavior/brokerMiFIDBehavior');

// @ actions
const BrokerWarrantsAdvancedBuyActions = require('actions/brokerWarrantsAdvancedBuy');
const WarrantFileActions = require('actions/brokerGetWarrantFile.js');
const BrokerConvenienceMiFIDTestAction = require('mifid/actions/brokerConvenienceMiFIDTest');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');

// @ constants
const {
    MYPROFILE_BROKER_EXPLORE_URL,
    MYPROFILE_BROKER_URL,
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_WARRANTS_ID,
    BROKER_WARRANTS_HELP_URL,
    BROKER_CONVENIENCE_MIFID_WARRANT,
    BROKER_MIFID_VERSION_2,
    BROKER_BUY_SCREEN
} = require('constants/index');

// @ helpers
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const { getDocumentURL } = require('utilities/stringHelper');

const WebappRender = require('components/conditionalRender/webappRender')
class BrokerWarrantsAdvancedBuyView extends React.Component {
    constructor(props) {
        super(props);
        this.buildWizard = this.buildWizard.bind(this);
        this.buildSuccessful = this.buildSuccessful.bind(this);
        this.getWarrantsDetails = this.getWarrantsDetails.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.getCatalogueDetails = this.getCatalogueDetails.bind(this);
    }

    componentDidMount() {
        const { match: { params }, setOrderID } = this.props;

        this.getWarrantsDetails();
        setOrderID(params.isin, params.iso);
        this.handleMifid(this.props);
        this.getCatalogueDetails();
        this.props.fetchOpenTraderLink();
    }

    componentWillReceiveProps(nextProps) {
        this.handleMifid(nextProps);
    }

    componentWillUnmount() {
        this.props.reset();
    }

    getBreadcrumbData(productFile, exchangeId, spcSymbol) {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerAdvancedSearch'),
                url: MYPROFILE_BROKER_EXPLORE_URL
            },
            {
                text: productFile.get('companyName'),
                url: `/myprofile/broker/productFile/${exchangeId}/${spcSymbol}`
            },
            {
                text: formatText('breadcrumb-brokerStocksBuy'),
                url: ''
            },
            {
                text: formatText('breadcrumb-brokerAdvancedOrder'),
                url: ''
            }
        ];
    }

    getWarrantsDetails() {
        const { getWarrantsDetails, match: { params: { isin, iso } } } = this.props;
        getWarrantsDetails(isin, iso, BROKER_BUY_SCREEN);
    }

    getCatalogueDetails() {
        this.props.getWarrantCatalogueDetails(this.props.match.params.isin);
    }

    buildSuccessful() {
        const { immBrokerWarrantsAdvancedBuy, immStocksContract, immProductFile } = this.props;

        return (
            <div className="row no-gutter">
                <BrokerWarrantsAdvancedBuySuccess
                    immProductFile={immProductFile}
                    immBrokerWarrantsAdvancedBuy={immBrokerWarrantsAdvancedBuy}
                    immStocksContract={immStocksContract}
                />
            </div>
        );
    }

    buildWizard() {
        const { immBrokerWarrantsAdvancedBuy, immStocksContract, immProductFile, immVariables } = this.props;
        const immSteps = immBrokerWarrantsAdvancedBuy.get('steps');
        const visibleStep = immBrokerWarrantsAdvancedBuy.get('visibleStep');
        const firstStepLoading = immBrokerWarrantsAdvancedBuy.getIn([
            'steps',
            FIRST_STEP,
            'loading'
        ]);
        const secondStepLoading = immBrokerWarrantsAdvancedBuy.getIn([
            'steps',
            SECOND_STEP,
            'loading'
        ]);
        const thirdStepLoading = immBrokerWarrantsAdvancedBuy.getIn([
            'steps',
            THIRD_STEP,
            'loading'
        ]);
        const actions = {
            setVisibleStep: this.props.setVisibleStep,
            setWillCancel: this.props.setWillCancel,
            finish: this.props.finish,
            validateStep: this.props.validateStep,
            cancel: this.handleCancel
        };
        const fees_url = getDocumentURL(immVariables.getIn(['variables', 'parameters', 'documents_urls', 'investments', 'wealth_rate']));
        const headerMenuData = {
            title: formatText('broker-stocksAdvancedBuyWizardTitle'),
            linksData: [
                {
                    label: formatText('broker-stocksAdvancedBuyWizardFirstLinkLabel'),
                    href: fees_url,
                    hasTooltip: false,
                    target: '__blank'
                },
                {
                    label: formatText('broker-stocksAdvancedBuyWizardSecondLinkLabel'),
                    href: BROKER_WARRANTS_HELP_URL,
                    hasTooltip: false,
                    target: '_blank'
                }
            ]
        };

        return (
            <Wizard
                wizardClass={'broker-warrants-advanced-buy__wizard'}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
                hasHeaderMenu={true}
                headerMenuData={headerMenuData}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    addLoadingBehaviour={false}
                    isLoading={firstStepLoading}
                >
                    <BrokerWarrantsAdvancedBuyStep1 />
                </WizardStep>
                <WizardStep
                    position="middle"
                    cancelButton={true}
                    addLoadingBehaviour={false}
                    isLoading={secondStepLoading}
                >
                    <BrokerWarrantsAdvancedBuyStep2
                        immBrokerWarrantsAdvancedBuy={immBrokerWarrantsAdvancedBuy}
                        immStocksContract={immStocksContract}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    immFinalButton="broker-stocksAdvancedBuyFinish"
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={thirdStepLoading}
                >
                    <BrokerWarrantsAdvancesBuyStep3
                        immProductFile={immProductFile}
                        immBrokerWarrantsAdvancedBuy={immBrokerWarrantsAdvancedBuy}
                        immStocksContract={immStocksContract}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    handleCancel() {
        this.props.history.push(`/myprofile/broker`);
    }

    handleMifid(/*props*/) {
        /*const productName = (props.immProductFile.get('companyName') || '').trim();

        if (!productName) {
            return;
        }

        const isin = props.params.isin;
        const iso = props.params.iso;

        const productUrl = `/myprofile/broker/warrantsProductFile/${isin}/${iso}`;
        const productMifidId = BROKER_CONVENIENCE_MIFID_TEST_WARRANTS_ID;
        const continuationUrl = `/myprofile/broker/warrantsAdvancedBuy/${isin}/${iso}`;

        props.onStartConvenienceMiFIDTest(
          productName,
          productUrl,
          productMifidId,
          continuationUrl,
          {
            productType: BROKER_CONVENIENCE_MIFID_WARRANT,
          }
        );*/
    }

    render() {
        const { immMyInvestments, immBrokerWarrantsAdvancedBuy, immOpenTrader, immProductFile, warrantFile } = this.props;
        const mappingBreadcrumb = this.getBreadcrumbData(immProductFile, this.props.match.params.exchangeId, this.props.match.params.spcSymbol);
        const productName = trim(this.props.immProductFile.get('companyName'));
        const isin = this.props.match.params.isin;
        const iso = this.props.match.params.iso;
        const productUrl = `/myprofile/broker/warrantsProductFile/${isin}/${iso}`;
        const continuationUrl = `/myprofile/broker/warrantsAdvancedBuy/${isin}/${iso}`;
        const mifidOptions = {
            productType: BROKER_CONVENIENCE_MIFID_WARRANT
        };

        let contractBoxContent;

        if (immBrokerWarrantsAdvancedBuy.get('submitSuccessful')) {
            contractBoxContent = this.buildSuccessful();
        } else {
            contractBoxContent = this.buildWizard();
        }

        return (
            <BrokerMiFIDBehavior
                mifidVersion={BROKER_MIFID_VERSION_2}
                productName={productName}
                productUrl={productUrl}
                continuationUrl={continuationUrl}
                productIsinId={isin}
                productMarketId={iso}
                productMifidId={BROKER_CONVENIENCE_MIFID_TEST_WARRANTS_ID}
                mifidOptions={mifidOptions}
            >
                <div className="broker-warrants-advanced-buy-view">
                    <OKCover size="medium" section="broker">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={getFinalTitle('broker-warrantsAdvancedBuyViewTitle')}
                        >
                            <OKButton inverse={true} modifier="ghost" to={MYPROFILE_BROKER_EXPLORE_URL}>
                                <FormattedText format="firstUppercase" value="broker-goToAdvancedSearch" />
                            </OKButton>
                            <WebappRender>
                                <OKButton inverse={true} modifier="primary" to={immOpenTrader.get('openTraderLink')}>
                                    <FormattedText format="firstUppercase" value="broker-openTraderLabel" />
                                </OKButton>
                            </WebappRender>
                        </OKHeaderSubPage>
                    </OKCover>
                    <section className="broker-warrants-advanced-buy-view__body">
                        <BrokerWarrantsHeader
                            productFile={immProductFile}
                            warrantFile={warrantFile}
                            immMyInvestments={immMyInvestments}
                            handleUpdate={this.getWarrantsDetails}
                            noBottomButtons={true}
                        />
                        <div className="broker-warrants-advanced-buy-view__wizard">
                            {contractBoxContent}
                        </div>
                    </section>
                </div>
            </BrokerMiFIDBehavior>
        );
    }
}

BrokerWarrantsAdvancedBuyView.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerWarrantsAdvancedBuy: PropTypes.object,
    immOpenTrader: PropTypes.object.isRequired,
    immProductFile: PropTypes.object,
    immStocksContract: PropTypes.object,
    immVariables: PropTypes.object.isRequired,
    reset: PropTypes.func,
    setVisibleStep: PropTypes.func,
    setWillCancel: PropTypes.func,
    validateStep: PropTypes.func,
    finish: PropTypes.func,
    match: PropTypes.object,
    getWarrantsDetails: PropTypes.func,
    setOrderID: PropTypes.func,
    onStartConvenienceMiFIDTest: PropTypes.func.isRequired,
    fetchOpenTraderLink: PropTypes.func.isRequired,
    immMyInvestments: PropTypes.func.isRequired,
    warrantFile: PropTypes.object,
};

module.exports.constructor = BrokerWarrantsAdvancedBuyView;
module.exports.BrokerWarrantsAdvancedBuyView = connect(
    state => ({
        immBrokerWarrantsAdvancedBuy: state.brokerWarrantsAdvancedBuy,
        immOpenTrader: state.brokerOpenTrader,
        immProductFile: state.brokerProductFile,
        immStocksContract: state.brokerStocksContract,
        immMyInvestments: state.brokerMyInvestments,
        immVariables: state.globalVariables,
        warrantFile: state.brokerWarrantsFile,
    }),
    {
        reset: BrokerWarrantsAdvancedBuyActions.reset,
        setVisibleStep: BrokerWarrantsAdvancedBuyActions.setVisibleStep,
        setWillCancel: BrokerWarrantsAdvancedBuyActions.setWillCancel,
        validateStep: BrokerWarrantsAdvancedBuyActions.validateStep,
        finish: BrokerWarrantsAdvancedBuyActions.finish,
        getWarrantsDetails: WarrantFileActions.getWarrantFile,
        getWarrantCatalogueDetails: WarrantFileActions.getWarrantCatalogueDetails,
        setOrderID: BrokerWarrantsAdvancedBuyActions.setOrderID,
        onStartConvenienceMiFIDTest: BrokerConvenienceMiFIDTestAction.start,
        fetchOpenTraderLink: BrokerOpenTraderActions.fetchLink
    }
)(withRouter(BrokerWarrantsAdvancedBuyView));
